module.exports = __webpack_public_path__ + "img/744.cc8eaa71.jpg";